import * as React from 'react';

import { PictureProfile } from '../../../ResizedImage/PictureProfile.csharp';
import { LinkViewModel } from '../../Common/LinkViewModel.csharp';
import { CartDrawerSettingsPageViewModel } from '../../Purchase/Cart/CartDrawer/Page/CartDrawerSettingsPageViewModel.csharp';
import { UserDetailsViewModel } from '../../Purchase/Cart/PersonalizedCart/UserDetailsViewModel.csharp';
import { CartV1 } from '../../Purchase/Cart/Widget/CartV1';
import { CartV2 } from '../../Purchase/Cart/Widget/CartV2';
import { ActionMenu } from '../../ReactComponents/ActionMenu/ActionMenu';
import { RxMenu } from '../../ReactComponents/RxMenu/RxMenu';
import { RxDetailedMaintenanceModel } from '../../Rx/RxDetailedMaintenanceModel.csharp';
import { HeaderLabelsViewModel } from './HeaderLabelsViewModel.csharp';
import { HeaderLinksViewModel } from './HeaderLinksViewModel.csharp';
import { RxHeaderLink } from './RxHeaderLink.csharp';

interface HeaderActionsProps {
    readonly isActionMenuOpen: boolean;
    readonly isRxMenuOpen: boolean;
    readonly headerLinks: HeaderLinksViewModel;
    readonly userDetails: UserDetailsViewModel | undefined;
    readonly setActionMenuOpen: (value: boolean) => void;
    readonly setRxMenuOpen: (value: boolean) => void;
    readonly togglePhysicalStoreMode: () => void;
    readonly isInPhysicalStoreMode: boolean;
    readonly cartItemPictureProfile: PictureProfile;
    readonly isCartVisible: boolean;
    readonly actionMenuProfileLinks: LinkViewModel[];
    readonly rxMenuTitle: string;
    readonly rxMenuTitleActiveBankIdSession: string;
    readonly rxMenuLinks: RxHeaderLink[];
    readonly rxMenuArticlesLinks: LinkViewModel[];
    readonly rxSessionCookieName: string;
    readonly rxSessionValidityCookieName: string;
    readonly rxSessionExpirationTimeCookieName: string;
    readonly rxSessionValidityDefaultTimeInMinutes: number;
    readonly rxSessionRedIndicatorThresholdInMinutes: number;
    readonly rxMenuMaintenance: RxDetailedMaintenanceModel;
    readonly unreadMessagesBadgeUrl: string;
    readonly customerServiceLabel?: string;
    readonly customerServicePhoneNumber: string;
    readonly cartDrawerSettings: CartDrawerSettingsPageViewModel;
    readonly headerLabels: HeaderLabelsViewModel;
    readonly prescriptionListPageUrl: string;
    readonly buyPrescriptionButtonText: string;
}

export const HeaderActions = (props: HeaderActionsProps) => {
    return (
        <ul className="Header__Actions">
            <li>
                <RxMenu
                    isActive={props.isRxMenuOpen}
                    setRxMenuOpen={(value) => props.setRxMenuOpen(value)}
                    rxMenuTitle={props.rxMenuTitle}
                    rxMenuTitleActiveBankIdSession={props.rxMenuTitleActiveBankIdSession}
                    rxLinks={props.rxMenuLinks}
                    articlesLinks={props.rxMenuArticlesLinks}
                    rxSessionCookieName={props.rxSessionCookieName}
                    rxSessionValidityCookieName={props.rxSessionValidityCookieName}
                    rxSessionExpirationTimeCookieName={props.rxSessionExpirationTimeCookieName}
                    rxSessionValidityDefaultTimeInMinutes={props.rxSessionValidityDefaultTimeInMinutes}
                    rxSessionRedIndicatorThresholdInMinutes={props.rxSessionRedIndicatorThresholdInMinutes}
                    unreadMessagesBadgeUrl={props.unreadMessagesBadgeUrl}
                    customerSupportLink={props.headerLinks.customerSupport}
                    customerServiceLabel={props.customerServiceLabel}
                    customerServicePhoneNumber={props.customerServicePhoneNumber}
                    showButtonLabel={props.headerLabels.showLabels}
                    buttonLabel={props.headerLabels.rxMenu}
                    prescriptionListPageUrl={props.prescriptionListPageUrl}
                    buyPrescriptionButtonText={props.buyPrescriptionButtonText}
                    maintenance={props.rxMenuMaintenance}
                />
            </li>
            <li>
                <ActionMenu
                    isActive={props.isActionMenuOpen}
                    isLoggedIn={props.userDetails?.isLoggedIn || false}
                    loginUrl={props.headerLinks.login}
                    logoutUrl={props.headerLinks.logout}
                    registerUrl={props.headerLinks.register}
                    firstName={props.userDetails?.firstName || ''}
                    lastName={props.userDetails?.lastName || ''}
                    setActionMenuOpen={(value) => props.setActionMenuOpen(value)}
                    isPhysicalStoreAdmin={!!props.userDetails?.isPhysicalStoreAdmin}
                    isInPhysicalStoreMode={props.isInPhysicalStoreMode}
                    onPhysicalStoreChange={props.togglePhysicalStoreMode}
                    profileLinks={props.actionMenuProfileLinks}
                    rxSessionCookieName={props.rxSessionCookieName}
                    rxSessionValidityCookieName={props.rxSessionValidityCookieName}
                    rxSessionExpirationTimeCookieName={props.rxSessionExpirationTimeCookieName}
                    showButtonLabel={props.headerLabels.showLabels}
                    buttonLabel={props.headerLabels.myPage}
                />
            </li>
            <li>
                {props.cartDrawerSettings.showNewAddToCart ? (
                    <CartV2
                        cartUrl={props.headerLinks.cart}
                        cartItemUrl={props.headerLinks.cartItem}
                        couponUrl={props.headerLinks.coupon}
                        cartSummaryUrl={props.headerLinks.cartSummary}
                        pictureProfile={props.cartItemPictureProfile}
                        displayCart={props.isCartVisible}
                        cartDrawerSettings={props.cartDrawerSettings}
                        showButtonLabel={props.headerLabels.showLabels}
                        buttonLabel={props.headerLabels.cart}
                    />
                ) : (
                    <CartV1
                        cartUrl={props.headerLinks.cart}
                        cartItemUrl={props.headerLinks.cartItem}
                        couponUrl={props.headerLinks.coupon}
                        cartSummaryUrl={props.headerLinks.cartSummary}
                        pictureProfile={props.cartItemPictureProfile}
                        displayCart={props.isCartVisible}
                        cartDrawerSettings={props.cartDrawerSettings}
                        showButtonLabel={props.headerLabels.showLabels}
                        buttonLabel={props.headerLabels.cart}
                    />
                )}
            </li>
        </ul>
    );
};
